/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Registration_Formtitle1Inputs */

const en_registration_formtitle1 = /** @type {(inputs: Registration_Formtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your account`)
};

/**
* | output |
* | --- |
* | "Create your account" |
*
* @param {Registration_Formtitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const registration_formtitle1 = /** @type {((inputs?: Registration_Formtitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Registration_Formtitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_registration_formtitle1(inputs)
});
export { registration_formtitle1 as "registration_formTitle" }